var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    attrs: { title: "補正登録", visible: _vm.dialogVisible, width: "65em" },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function() {
          return [
            _c("FeesForWeightAndNoiseForm", {
              ref: "feesForWeightAndNoiseForm",
              attrs: {
                "label-width": "10em",
                formMode: "register",
                billingYmMode: "this",
                "autocomplete-customer-code-set":
                  _vm.autocompleteCustomerCodeSet,
                "autocomplete-registration-symbol-set":
                  _vm.autocompleteRegistrationSymbolSet,
                "autocomplete-airport-code-set": _vm.autocompleteAirportCodeSet,
                "autocomplete-model-code-set": _vm.autocompleteModelCodeSet
              },
              model: {
                value: _vm.feesForWeightAndNoiseFormModel,
                callback: function($$v) {
                  _vm.feesForWeightAndNoiseFormModel = $$v
                },
                expression: "feesForWeightAndNoiseFormModel"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("RegisterDialogFooter", {
              on: { clear: _vm.clickClear, register: _vm.clickRegister }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }